// Decorative elements that evoke baby sleep.
// FloatingMoon uses the SVG inline so it scales perfectly and blends
// with the background via mix-blend-mode + low opacity + soft glow.

export function FloatingMoon({
  className = "",
  size = 140,
  tone = "light",
  float = true,
  glow = true,
}) {
  // tone: "light" for dark backgrounds (white moon, screen blend, low opacity)
  //        "dark" for light backgrounds (deep violet moon, multiply blend)
  const isLight = tone === "light";
  const color = isLight ? "#ffffff" : "#5b21b6";
  const opacity = isLight ? 0.18 : 0.14;
  const blendMode = isLight ? "screen" : "multiply";

  return (
    <div
      className={`${className} pointer-events-none ${float ? "moon-float" : ""}`}
      style={{
        width: size,
        height: size,
        opacity,
        mixBlendMode: blendMode,
        filter: glow
          ? `drop-shadow(0 0 ${size * 0.35}px ${isLight ? "rgba(196,181,253,0.55)" : "rgba(91,33,182,0.35)"})`
          : "none",
      }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24"
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.5 2.518a9.5 9.5 0 1 0 11.982 11.982 8 8 0 0 1-11.982-11.982z"
          fill={color}
        />
        <path
          d="M16.5 3 Q16.5 6.5 20 6.5 Q16.5 6.5 16.5 10 Q16.5 6.5 13 6.5 Q16.5 6.5 16.5 3 Z"
          fill={color}
        />
      </svg>
    </div>
  );
}

export function FloatingCloud({ className = "", size = 140 }) {
  return (
    <svg
      width={size}
      height={size * 0.6}
      viewBox="0 0 140 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} pointer-events-none`}
      aria-hidden="true"
    >
      <path
        d="M30 60c-11 0-20-8-20-18s9-18 20-18c3 0 6 .6 8.5 1.7C42 16 50 9 60 9c12 0 22 9 23 21h8c10 0 18 8 18 18s-8 18-18 18H30z"
        fill="currentColor"
        fillOpacity="0.18"
      />
    </svg>
  );
}

export function Sparkle({ className = "", size = 24, twinkleDelay = 0 }) {
  const delayClass =
    twinkleDelay === 1
      ? "twinkle-delay-1"
      : twinkleDelay === 2
        ? "twinkle-delay-2"
        : twinkleDelay === 3
          ? "twinkle-delay-3"
          : "";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} pointer-events-none twinkle ${delayClass}`}
      aria-hidden="true"
    >
      <path
        d="M12 2l1.7 6.3L20 10l-6.3 1.7L12 18l-1.7-6.3L4 10l6.3-1.7L12 2z"
        fill="currentColor"
        fillOpacity="0.65"
      />
    </svg>
  );
}

export function SleepZ({ className = "", size = 48 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} pointer-events-none`}
      aria-hidden="true"
    >
      <text
        x="6"
        y="20"
        fontFamily="Cormorant Garamond, serif"
        fontSize="18"
        fontStyle="italic"
        fill="currentColor"
        fillOpacity="0.35"
      >
        z
      </text>
      <text
        x="18"
        y="30"
        fontFamily="Cormorant Garamond, serif"
        fontSize="24"
        fontStyle="italic"
        fill="currentColor"
        fillOpacity="0.5"
      >
        Z
      </text>
      <text
        x="30"
        y="44"
        fontFamily="Cormorant Garamond, serif"
        fontSize="34"
        fontStyle="italic"
        fill="currentColor"
        fillOpacity="0.65"
      >
        Z
      </text>
    </svg>
  );
}
